<template>
  <div>
    <table :class="classNames">
      <thead>
        <list-header
          :titles="titles"
          :selectedTitle="selectedItem"
          v-on:onSelectChange="onSelectChange"
        />
      </thead>
      <tbody>
        <template v-for="item in items">
          <!-- <filterable
            :key="item.id"
            :ref="item.id"

            :item="item"
            @validation="(value) => showItem(value, item.id)"
          > -->
          <list-item
            :key="item.id"
            :item="item"
            :black-listed-items="hiddenItems"
            :clickable="rowClickable"
          />
          <!-- </filterable> -->
        </template>
      </tbody>
    </table>

    <div class="note">
      Vanwege de overgang naar een andere inwonerscategorie is hier geen positie genoteerd.
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { BLACK_LISTED_ITEMS, SELECTABLE_ITEMS } from '@/config/list.config';

export default {
  name: 'List',

  props: {
    /**
     * What theme should the table have
     */
    theme: {
      type: String,
      required: false,
      default: 'light',
      validator: (value) => [
        'light',
        'dark',
      ].includes(value),
    },

    /**
     * What types should the table have
     */
    type: {
      type: String,
      required: false,
      default: '',
      validator: (value) => [
        '',
        'striped',
        'bordered',
      ].includes(value),
    },

    /**
     * Is a row clickable; when it's the rows gets a hover effect
     */
    rowClickable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      blackListedItems: BLACK_LISTED_ITEMS,
      hiddenItems: BLACK_LISTED_ITEMS.concat(
        SELECTABLE_ITEMS.filter(
          (item) => item !== SELECTABLE_ITEMS[0],
        ),
      ),
      selectedItem: SELECTABLE_ITEMS[0],
      states: {
        '0,25000': 'small',
        '25000,50000': 'medium',
        '50000,100000': 'normal',
        '100000,20000000': 'large',
      },
    };
  },

  computed: {
    ...mapState({
      data: (state) => state.rawData.data,
      sepData: (state) => state.rawData.sepData,
      selectedYear: (state) => state.rawData.year,
    }),

    ...mapGetters({
      statedFilters: 'filter/filters',
    }),

    items() {
      const state = this.states[this.statedFilters.Inwoners.value[0]];

      return this.sepData[this.selectedYear][state];
    },

    firstItem() {
      const firstKey = Object.keys(this.data)[0];

      return this.data[firstKey][0];
    },

    titles() {
      const keys = [];

      Object.keys(this.firstItem).forEach((key) => {
        if (this.blackListedItems.includes(key.toLowerCase())) {
          return;
        }

        keys.push(key);
      });

      return keys;
    },

    classNames() {
      const classNames = ['list'];

      if (this.theme) {
        classNames.push(`list--${this.theme}`);
      }

      if (this.type) {
        classNames.push(`list--${this.type}`);
      }

      if (this.rowClickable) {
        classNames.push('list--hoverable');
      }

      return classNames;
    },
  },

  methods: {
    showItem(value, itemId) {
      if (this.$refs
          && this.$refs[itemId]
          && this.$refs[itemId][0]
          && this.$refs[itemId][0].$children
          && this.$refs[itemId][0].$children[0]
      ) {
        this.$refs[itemId][0].$children[0].toggleItem(value);
      }
    },

    onSelectChange(value) {
      this.selectedItem = value;
      this.hiddenItems = BLACK_LISTED_ITEMS.concat(
        SELECTABLE_ITEMS.filter((item) => item !== value),
      );
    },
  },
};
</script>

<style lang="scss">
  .note {
    @include font-size(iota);

    margin-top: $global-spacing-unit;
    padding-left: $global-spacing-unit-half;
    position: relative;

    &::before {
      content: '*';
      left: 0;
      position: absolute;
      top: 0;
    }
  }

  .list {
    border: 0;
    border-collapse: collapse;
    border-spacing: 0;
    min-width: 100%;
    width: 345px;

    td, th {
      padding-left: $global-spacing-unit-threequarter;
    }

    &--striped {
      tbody tr:nth-of-type(odd) {
        background-color: rgba($color-black, .05);
      }
    }

    &--bordered {
      border-collapse: collapse;

      td, th {
        border: solid 1px $color-geyser;
        padding: $global-spacing-unit-quarter;
      }
    }

    &--hoverable {
      tbody tr:hover {
        background-color: rgba($color-black, .05);
        cursor: pointer;
      }
    }

    &--dark {
      background-color: $color-shark;
      color: $color-white;

      &.list--striped {
        tbody tr:nth-of-type(odd) {
          background-color: rgba($color-white, .05);
        }
      }

      &.list--bordered {
        td, th {
          border-color: $color-outer-space;
        }
      }

      &.list--hoverable {
        tbody tr:hover {
          background-color: rgba($color-white, .13);
        }
      }
    }

    tbody tr.is-active,
    tbody tr.is-active:hover {
      background-color: rgba($color-black, .05);
    }

    td:first-child, th:first-child {
      padding-left: 0;
    }
  }
</style>
